// extracted by mini-css-extract-plugin
export var content = "_po-1";
export var fullScreen = "_po-0";